import { Component, OnInit } from '@angular/core';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-fleet-history-board-page',
  templateUrl: './user-profile-fleet-history-board-page.component.html',
  styleUrls: ['./user-profile-fleet-history-board-page.component.scss'],
})
export class UserProfileFleetHistoryBoardPageComponent implements OnInit {
  constructor(
    private api: UserApiService,
    private message: MessageService
  ) {
  }

  ngOnInit(): void {
    this.findAnnouncements();
  }

  loading = false;
  announcements: any[] = [];
  async findAnnouncements() {
    try {
      this.loading = true;
      const r = await this.api.findAnnouncements();
      this.announcements = r.data;
    } catch (error) {
      this.message.warn('网络问题');
    } finally {
      this.loading = false;
    }
  }
}
